import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'db-ai-builder-create-page-preview-demo',
    templateUrl: './ai-builder-create-page-preview-demo.component.html',
    styleUrls: ['./ai-builder-create-page-preview-demo.component.scss'],
    standalone: false
})
export class AiBuilderCreatePagePreviewDemoComponent {

  @Output() onBack: EventEmitter<{ step: string | void, templateScreenshot?: string, selectedCategory?: string }> = new EventEmitter<{ step: string | void, templateScreenshot?: string, selectedCategory?: string }>();
  @Input() templateScreenshot: string;
  @Input() selectedCategory: string;
  @Input() hideBackButton?: boolean;
}
